import { Component, Output, EventEmitter, OnInit } from '@angular/core';
import { SidebarStateService } from '../../../services/sidebar-state/sidebar-state.service';
import { IconsModule } from '../../../icons/icons.module';
import { CommonModule } from '@angular/common';
import { SidebarMenuComponent } from '../zikata-sidebar-menu/zikata-sidebar-menu.component';
import { LogoComponent } from '../../elements/zikata-logo/zikata-logo.component';
@Component({
  selector: 'zikatagov-sidebar',
  template: `
    <div
      class="sidebar d-flex flex-column h-100 bg-white border-end"
      [ngClass]="{
        'sidebar-collapsed': isCollapsed,
        'sidebar-mobile': isMobile,
        'sidebar-mobile-open': isMobile && !isCollapsed
      }"
    >
      <div class="p-3 d-flex justify-content-between align-items-center">
        <zikatagov-logo
          [logoSrc]="'assets/images/Ellipse 2.svg'"
          [width]="isMobile ? 32 : 40"
          [height]="isMobile ? 32 : 40"
        ></zikatagov-logo>
        <button
          class="btn btn-sm btn-link ml-0"
          (click)="toggleSidebar()"
          [attr.aria-label]="isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'"
        >
         <ng-icon
            name="saxMenuOutline"
            [size]="isMobile ? '16' : '12'"
            class="text-pink"
          ></ng-icon>
        </button>
      </div>
      <zikatagov-sidebar-menu
        [showOnlyIcons]="isCollapsed && !isMobile"
        [activeItemId]="activeItemId"
        (menuItemClick)="onMenuItemClick($event)"
        class="flex-grow-1"
      >
      </zikatagov-sidebar-menu>
      <div class="p-3 mt-auto">
        <button class="btn btn-outline-secondary w-100" (click)="onLogout()">
          <ng-icon name="saxLogoutOutline" [size]="isMobile ? '24' : '20'"></ng-icon>
          <span *ngIf="!isCollapsed || isMobile" class="ms-2">Logout</span>
        </button>
      </div>
    </div>
  `,
  standalone: true,
  imports: [CommonModule, IconsModule, SidebarMenuComponent, LogoComponent],
  styles: [`
    .sidebar {
      width: 250px;
      transition: all 0.3s ease;
      position: relative;
      z-index: 1030;
    }

    .sidebar-collapsed {
      width: 80px;
    }

    @media (max-width: 767.98px) {
      .sidebar {
        position: fixed;
        top: 0;
        left: -250px;
        height: 100vh !important;
        box-shadow: none;
      }

      .sidebar-mobile {
        width: 280px;
      }

      .sidebar-mobile-open {
        left: 0;
        box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
      }

      .sidebar-collapsed {
        left: -280px;
      }
    }
  `],
})
export class SidebarComponent implements OnInit {
  @Output() menuItemClick = new EventEmitter<number>();
  @Output() logout = new EventEmitter<void>();

  isCollapsed = false;
  isMobile = false;
  activeItemId: number | null = null;

  constructor(private sidebarStateService: SidebarStateService) {}

  ngOnInit() {
    this.sidebarStateService.isCollapsed$.subscribe(
      (isCollapsed) => (this.isCollapsed = isCollapsed)
    );
    this.sidebarStateService.activeItemId$.subscribe(
      (activeItemId) => (this.activeItemId = activeItemId)
    );
    this.sidebarStateService.isMobile$.subscribe(
      (isMobile) => (this.isMobile = isMobile)
    );
  }

  onMenuItemClick(id: number) {
    this.sidebarStateService.setActiveItem(id);
    this.menuItemClick.emit(id);
    if (this.isMobile) {
      this.sidebarStateService.collapse(true);
    }
  }

  onLogout() {
    this.logout.emit();
  }

  toggleSidebar() {
    this.sidebarStateService.toggleSidebar();
  }
}
